<template>
  <button class="button" @click="fn(fnData)">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'selection-panel',
  props: {
    fn: {
      type: Function,
      required: true
    },
    fnData: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    border: none;
    background: transparent;
    cursor: pointer;
    height: 50px;
    padding: 0;

    &:active,
    &:focus {
      outline: none
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/JsButton.vue